import { render, staticRenderFns } from "./ValuationHistory.vue?vue&type=template&id=08c877f4&scoped=true&"
import script from "./ValuationHistory.vue?vue&type=script&lang=js&"
export * from "./ValuationHistory.vue?vue&type=script&lang=js&"
import style0 from "./ValuationHistory.vue?vue&type=style&index=0&id=08c877f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c877f4",
  null
  
)

export default component.exports